import initialState from './initialState';
import { FETCH_KPI_DATA, RECEIVE_KPI_DATA } from '../actions/actionTypes';

export default function kpis(state = initialState.kpis, action) {
  switch (action.type) {
    case FETCH_KPI_DATA:
      return action;
    case RECEIVE_KPI_DATA:
      return action.data;
    default:
      return state;
  }
}
